import RegistrationsActiveAttendeesOverTime from './registrations-active-attendees-over-time-container';

export default RegistrationsActiveAttendeesOverTime;
